export const getAddressComponentValue = (
  components: any[] | undefined,
  priorityTypes: readonly string[]
): string => {
  if (!Array.isArray(components)) return "";

  const byType: Record<string, string> = {};
  components.forEach((component) => {
    component.types?.forEach((type: string) => {
      if (!Object.prototype.hasOwnProperty.call(byType, type)) byType[type] = component.long_name;
    });
  });

  for (const type of priorityTypes) {
    if (byType[type]) return byType[type];
  }

  return "";
};

export const CITY_COMPONENT_TYPE_PRIORITY = [
  "locality",
  "sublocality_level_1",
  "sublocality",
  "postal_town",
  "neighborhood",
] as const;
